{
  "more_actions": {
    "removed_history": "Removed History",
    "list_settings": "List Settings",
    "manage_columns": "Manage Columns",
    "reminder": "Reminder",
    "add_comment": "Add Comment",
    "api_connections": "API Connections"
  },
  "lists": {
    "name_required": "Please enter a list name",
    "create_list": "Create List",
    "name": "Name",
    "enable_duplicate_contacts": "Enable duplicate contacts",
    "duplicate_contacts_tooltip": "Enabling duplicate contacts allows for multiple entries in forms. However, please note that importing and exporting data may not function properly.",
    "rename": "Rename List",
    "new_contact_list": "New Contact List",
    "more_actions": {
      "request_contacts": "Request Contacts",
      "clean_list": "Clean List",
      "connected_to": "Connected to",
      "sync_with": "Sync with"
    },
    "remove_from_contact_list_multiple": "These contacts will be removed from this list."
  },
  "company_list": {
    "shared_company_list": "shared company list",
    "personal_company_list": "personal company list",
    "project_company_list": "project company list",
    "list_memberships": "List memberships",
    "import_companies": "Import companies",
    "add_company": "Add Company",
    "add_to_list": "Add to List",
    "edit_company_type": "Edit Company Type",
    "bulk_edit": "Bulk Edit",
    "remove": "Remove",
    "list": "List",
    "company": "Company",
    "add_company_to_list": "Add Company to List",
    "bulk_edit_custom_fields": "Bulk Edit Custom Fields",
    "edit_custom_fields": "Edit Custom Fields",
    "please_select_company": "Please select a company to add to this list",
    "please_choose_list": "Please choose a list",
    "which_company_placeholder": "Which company do you want to add to this list",
    "action_cannot_be_undone": "This action cannot be undone",
    "delete_tab_confirmation": "Are you sure you want to delete this tab?",
    "company_removed_from_list": "The company will be removed from this list.",
    "remove_company_confirmation": "Are you sure you want to remove the company from this list?",
    "remove_company_aria_label": "remove company from this list",
    "loading_companies": "loading companies",
    "more_companies_contact_support": "There are more companies than shown. Please contact NEXL support.",
    "grid": {
      "columns": {
        "company": "Company",
        "open_tasks": "Open Tasks",
        "last_updated": "Last Updated",
        "company_domain": "Company Domain",
        "location": "Location",
        "contact_count": "Contact Count",
        "number_of_employees": "Number of Employees",
        "relationship_partner": "Relationship Partner",
        "type": "Type",
        "engagement": "Engagement",
        "last_interaction": "Last Interaction",
        "last_meeting": "Last Meeting",
        "last_sent_email_at": "Last Sent Email At",
        "last_received_email_at": "Last Received Email At",
        "last_bd_interaction_at": "Last BD Interaction At",
        "last_marketing_interaction_at": "Last Marketing Interaction At",
        "number_of_interactions": "Number Of Interactions",
        "number_of_meetings": "Number Of Meetings",
        "number_of_sent_emails": "Number Of Sent Emails",
        "number_of_received_emails": "Number Of Received Emails",
        "number_of_total_emails": "Number Of Total Emails",
        "tags": "Tags",
        "industry_names": "Industry Names",
        "internal_industry_names": "Internal Industry Names",
        "website": "Website",
        "linkedin_url": "Linkedin Url",
        "twitter_url": "Twitter Url",
        "correspondence_numbers": "Correspondence Numbers",
        "correspondence_emails": "Correspondence Emails",
        "client_id": "Client ID",
        "group_id": "Group ID",
        "edit": "Edit"
      }
    }
  },
  "my_lists": {
    "page": {
      "create_list": "Create List",
      "search_placeholder": "Search lists...",
      "lists_header": "Lists"
    },
    "empty_states": {
      "no_shared_list": "No shared list",
      "your_list_is_empty": "Your List is Empty",
      "no_lists_found": "No Lists Found",
      "no_search_results": "We couldn't find any list matching your search. Try using different keywords or create a new list",
      "list_not_found": "List not found"
    },
    "table": {
      "columns": {
        "name": "Name",
        "location": "Location",
        "created_at": "Created At",
        "created_by": "Created By",
        "last_viewed": "Last Viewed",
        "actions": "Actions"
      }
    },
    "actions": {
      "add_to_list": "Add to List",
      "list_actions": "List actions",
      "rename_list": "Rename List",
      "share_list": "Share List",
      "add_company": "Add Company",
      "add_contact": "Add Contact",
      "add_generic_item": "Add Item",
      "add_activity": "Add Activity",
      "add_column": "Add Column",
      "share": "Share"
    },
    "forms": {
      "list_name": "List Name",
      "list_name_required": "Please enter a list name",
      "invite": "Invite",
      "invitee_required": "Please choose at least one invitee",
      "enable_duplicate_contacts": "Enable duplicate contacts",
      "duplicate_contacts_tooltip": "Enabling duplicate contacts allows for multiple entries in forms. However, please note that importing and exporting data may not function properly."
    },
    "confirmations": {
      "archive_list_title": "Archive List?",
      "archive_list_content": "Are you sure you want to archive this list? It will be removed from the listing.",
      "remove_user_title": "Are you sure you want to remove this user?",
      "remove_user_content": "Click confirm to remove"
    },
    "share": {
      "invite_tab": "Invite",
      "access_tab": "Access",
      "owner": "Owner",
      "success_message": "Your list has been successfully shared. We will notify the recipients.",
      "loading_users": "Loading users"
    },
    "scopes": {
      "all": {
        "name": "Search Lists",
        "description": "Search for a list you have access to or select from your recently viewed lists."
      },
      "created": {
        "name": "Created by Me",
        "description": "Here are your recently created items. Use search to find others and stay organized tracking your work."
      },
      "shared": {
        "name": "Shared with Me",
        "description": "Search to find a list or select from one of your recent lists shared with you."
      },
      "workspace": {
        "name": "Workspace Lists",
        "description": ""
      },
      "app": {
        "name": "Apps Lists",
        "description": ""
      },
      "marketing": {
        "name": "Marketing Lists",
        "description": ""
      }
    },
    "navigation": {
      "other_lists": "Other Lists"
    },
    "types": {
      "contact_list": "Create a List of Contacts for your project",
      "company_list": "Create a List of Companies for your project",
      "generic_list": "Create custom list to support your project"
    },
    "empty_descriptions": {
      "shared": "It looks like no one has shared any lists with you yet. When someone shares a list, it will appear here.",
      "marketing": "Start creating your list on Marketing to see them here.",
      "app": "Start creating your list on Apps to see them here.",
      "workspace": "Start creating your list on Workspace to see them here.",
      "default": "Start creating your list to see them here."
    }
  },
  "company_list_grid": {
    "add_company": "Add Company",
    "add_to_list": "Add to List",
    "edit_company_type": "Edit Company Type",
    "bulk_edit": "Bulk Edit",
    "remove": "Remove",
    "import_companies": "Import companies"
  },
  "removed_history": {
    "title": "Removed History",
    "empty_state": {
      "title": "No Removed Contacts",
      "description": "No contacts have been removed from this list yet. Once contacts are removed, they will appear here."
    },
    "table": {
      "selected_count": "{{count}} selected",
      "headers": {
        "contact": "Contact",
        "company": "Company",
        "removed_date": "Removed Date",
        "removed_by": "Removed By"
      }
    },
    "actions": {
      "add_to_list": "Add to list",
      "go_back_tooltip": "go back to {{listName}}"
    }
  },
  "e_marketing_integration": {
    "settings": {
      "title": "eMarketing Settings",
      "sync_to_tools": "Sync to eMarketing Tools",
      "sync_to_tools_caption": "Each time you sync to an eMarketing tools, a new list will be created to their app. You can choose which fields to map, ensuring the right data is included."
    },
    "sync": {
      "title": "Sync Contacts",
      "save_and_sync": "Save and Sync",
      "connector_name": "Connector Name",
      "e_marketing_list_name": "eMarketing List Name",
      "e_marketing_list_name_caption": "If a list with the same name exists in the eMarketing tool, it will be overwritten.",
      "type_connector_name": "Type connector name",
      "select_connector": "Select connector",
      "syncing_tooltip": "Syncing contacts with the eMarketing tool is in progress.",
      "syncing_status": "Syncing..."
    },
    "status": {
      "out_of_sync_title": "List out of sync.",
      "sync_now": "Sync now",
      "sync_now_description": "to update your data.",
      "sync_complete_title": "Sync Complete:",
      "sync_complete_description": "Your contact list has been synced to",
      "sync_complete_on": "on",
      "sync_failed_title": "Sync Failed:",
      "sync_failed_description": "This may be due to connection issues or incorrect settings. Open",
      "e_marketing_setup": "eMarketing setup",
      "retry_description": "to retry again."
    },
    "disconnect": {
      "title": "Delete Connection?",
      "description": "Are you sure you want to delete this connection? This action will remove the integration, and any ongoing syncs will be stopped. This cannot be undone.",
      "aria_label": "Delete connection",
      "button_title": "Delete connection"
    },
    "field_mapping": {
      "title": "Fields to Map",
      "nexl_fields": "Nexl Fields",
      "concep_fields": "Concep Fields",
      "add_map_field": "Add Map Field",
      "select_nexl_field": "Select Nexl Field",
      "select_remote_field": "Select Remote Field",
      "remove_field_mapping": "Remove field mapping {{index}}"
    }
  },
  "list_cleaner": {
    "status_result": "Status Result",
    "last_verified": "Last verified",
    "verify_list": {
      "button": "Verify List",
      "verifying": "Verifying List",
      "confirmation_title": "Verify List",
      "confirmation_content": "Validate email addresses for accuracy before sending campaigns."
    },
    "table": {
      "headers": {
        "contact": "Contact",
        "company": "Company",
        "location": "Location",
        "last_interaction": "Last Interaction",
        "consent_status": "Consent Status",
        "reason": "Reason",
        "result": "Result",
        "status": "Status",
        "action": "Action"
      },
      "selected_count": "{{count}} selected"
    },
    "actions": {
      "mark_as_low_risk": "Mark as Low Risk",
      "remove_from_list": "Remove from List",
      "list_cleaner_actions": "list cleaner actions"
    },
    "contact_status": {
      "bounced": "Remove bounced",
      "consent_not_given": "Remove from List",
      "total": "Remove from List",
      "unengaged": "Remove unengaged",
      "user_unsubscribed": "Remove unsubscribed"
    },
    "status_labels": {
      "bounced": "Bounced",
      "consent_not_given": "Consent Not Given",
      "total": "Total",
      "unengaged": "Unengaged",
      "user_unsubscribed": "User Unsubscribed"
    },
    "risk": {
      "high_risk": "High Risk",
      "medium_risk": "Medium Risk",
      "low_risk": "Low Risk",
      "unknown_risk": "Unknown Risk",
      "risk_with_level": "{{level}} RISK",
      "tooltips": {
        "high": "Sending to this highly risky address will harm your reputation.",
        "medium": "This is our neutral risk level. Emails not classified as low or high risk default to medium risk.",
        "low": "The email address is likely valid, and sending to it poses a low risk to your reputation."
      }
    },
    "confirmations": {
      "mark_low_risk_title": "Mark as Low Risk?",
      "mark_low_risk_content": "Contacts marked as High Risk are skipped from Campaigns. Marking Contact as Low Risk will trigger campaign delivery to the contact.\n\nIf the email is validated again within the next 3 months, the Low Risk status will be preserved. After this period, if the contact is revalidated, Risk Status will be refreshed.",
      "remove_from_list_title": "Remove from list?",
      "remove_from_list_single": "This contact will be removed from your list.",
      "remove_from_list_multiple": "These contacts will be removed from your list.",
      "remove_all_contacts_title": "Remove all {{type}} contacts from list?",
      "remove_all_contacts_content": "These contacts will be removed from your list."
    },
    "success": {
      "contacts_cleaned_title": "{{type}} Contacts Cleaned!",
      "contacts_cleaned_description": "All {{type}} contacts have been removed. Your list is now more effective and deliverable!"
    },
    "remove_cleaned": {
      "ok": "Ok"
    }
  },
  "contact_list_grid": {
    "actions": {
      "add_contact": "Add Contact",
      "import_contacts": "Import contacts",
      "export": "Export",
      "refresh": "Refresh",
      "share": "Share",
      "sync_contacts": "Sync Contacts",
      "syncing": "Syncing",
      "add_tags": "Add Tags",
      "bulk_edit": "Bulk Edit",
      "log_new_activity": "Log New Activity"
    },
    "sync": {
      "failed": "Sync Failed",
      "try_again": "Try Again",
      "out_of_sync": "List out of sync. Sync now to update your data.",
      "complete": "Sync Complete: Your contact list has been synced to {{campaignManagerName}}!",
      "in_progress": "Syncing list, this might take a few minutes..."
    },
    "status": {
      "loading_contacts_aria": "loading contacts",
      "error_prefix": "Error: {{message}}",
      "over_limit": "This list is over the limit, showing only {{count}}.",
      "outdated_list": "The list you are viewing is outdated, click refresh to view the latest changes."
    },
    "tooltips": {
      "duplicate_contacts": "Enabling duplicate contacts allows for multiple entries in forms. However, please note that importing and exporting data may not function properly."
    }
  },
  "expiry": {
    "description": "Set condition to automatically close form submissions.",
    "enable_label": "Enable Expiry Date",
    "date_label": "Expiry Date",
    "date_placeholder": "When will the form expire?",
    "page_header_label": "Expiry Page Header",
    "page_header_placeholder": "Please enter expiry page header",
    "page_description_label": "Expiry Page Description",
    "default_header": "Form Has Expired",
    "default_description": "This form has expired and can no longer be accessed. Please contact the form owner for further assistance.",
    "validation": {
      "date_required": "Please select an expiry date",
      "date_past": "Date time can't be in the past",
      "header_required": "Please enter expiry page header"
    }
  },
  "views": {
    "default_view": "Default View",
    "views_label": "Views",
    "create_view": "Create View",
    "edit_view": "Edit View",
    "delete_view": "Delete View",
    "share_view": "Share View",
    "view_name_label": "View Name",
    "view_actions_aria": "view actions for {{viewName}}",
    "select_view_aria": "Select {{viewType}} View",
    "choose_single_select_column": "Choose Single Select Column",
    "choose_column": "Choose Column",
    "single_select_tooltip": "Refers to a type of field that allows users to choose only one option from a predefined set of options",
    "view_types": {
      "list": "List",
      "board": "Board",
      "calendar": "Calendar",
      "timeline": "Timeline",
      "unknown": "{{new_type}}"
    },
    "list": {
      "description": "Organize information in a table. Best for an overview all contacts, tasks, tags, assignees, and due dates."
    },
    "board": {
      "description": "Visualize your data in a board. Requires single select field."
    },
    "calendar": {
      "description": "See your data in calendar. Requires at least one date field."
    },
    "timeline": {
      "description": "Visualize your data in a timeline. Requires at least one date field."
    },
    "permissions": {
      "read_only": "Read-Only",
      "edit_description": "Allowed to edit the list and add new contacts",
      "read_only_description": "Allowed to view the list and contact details but cannot make any changes",
      "anyone_can_edit": "Anyone with link can edit",
      "anyone_can_view": "Anyone with link can view",
      "anyone_can_read_only": "Anyone with link can read-only"
    },
    "share": {
      "share_view_title": "Share View",
      "item_label": "Item",
      "permission_label": "Permission",
      "copy_link": "Copy Link",
      "link_copied": "Link Copied!",
      "invite_member": "Invite Member",
      "link_copied_tooltip": "Link copied!",
      "copy_link_description": "Enter the user's email or name to share a view, or copy",
      "this_link": "this link",
      "to_share": "to share",
      "copy_link_aria": "copy this link to share",
      "success_message": "List View has been successfully shared. We will notify the recipients.",
      "create_new_view_message": "Create a new view to share",
      "invite_required": "Please invite at least one member"
    },
    "confirmations": {
      "delete_content": "Click confirm to delete view"
    },
    "validation": {
      "name_required": "Please enter a name"
    }
  },
  "all_or_my_external_filter": {
    "all": "All",
    "my_contacts": "My Contacts",
    "all_contacts_aria": "Show All Contacts",
    "my_contacts_aria": "Show My Contacts",
    "my_companies": "My Companies",
    "all_companies_aria": "Show All Companies",
    "my_companies_aria": "Show My Companies"
  },
  "generic_list": {
    "slide": {
      "preview": "Preview",
      "overview": "Overview",
      "tasks": "Tasks"
    },
    "actions": {
      "create_row": "Create Row",
      "import_items": "Import items",
      "edit_row": "edit row",
      "open_slide": "open slide"
    },
    "forms": {
      "new_row": "New Row",
      "edit_row": "Edit Row",
      "bulk_edit_rows": "Bulk Edit Rows"
    },
    "status": {
      "over_limit": "There are more items than shown. Please contact NEXL support.",
      "loading_items": "loading items"
    },
    "confirmations": {
      "remove_rows_one": "Please confirm you want to remove this row",
      "remove_rows_other": "Please confirm you want to remove these rows"
    }
  },
  "forms": {
    "link_campaign": {
      "title": "Link Campaign to a Form",
      "description": "Get form link to add to your campaign",
      "button": "Link Form",
      "generating": "Generating URL",
      "no_url_error": "No URL found. Please contact support."
    },
    "prefill": {
      "label": "Pre-fill fields on the form",
      "tooltip": "When enabled, contact information from your campaign will automatically populate form fields"
    },
    "form_selection": {
      "label": "Form",
      "placeholder": "Please select a form",
      "generate_link": "Generate Link"
    },
    "add": {
      "title": "FORM",
      "label": "Form",
      "button": "Add form",
      "contact_list_form": "Contact List Form"
    },
    "empty": {
      "message": "Start creating new form here."
    },
    "rename": {
      "placeholder": "Enter Form Name"
    },
    "sync": {
      "stats_button": "Sync Stats",
      "working_message": "We are working on this, please come back in a few minutes and refresh the page..."
    },
    "actions": {
      "edit": "Edit",
      "rename": "Rename",
      "copy_link": "Copy form link for EMS"
    },
    "delete": {
      "confirmation": "Are you sure you want to delete this form?",
      "title": "Delete Form",
      "button": "Delete"
    },
    "status": {
      "expired": "Expired",
      "draft": "Draft",
      "unpublished_changes": "Unpublished Changes",
      "published": "Published"
    },
    "preview": {
      "loading": "Loading Form...",
      "redirecting": "Redirecting...",
      "required_fields_empty": "Required fields are empty",
      "submit": "Submit",
      "supported_by": "Supported by",
      "display_not_supported": "Display As not Supported"
    },
    "contact_label": "Contact",
    "contact_placeholder": "Which contact do you want to merge into",
    "email_placeholder": "Type the email address",
    "new_contact_header": "New Contact",
    "list_label": "List",
    "please_choose_list": "Please choose a list"
  },
  "actions": {
    "add_contact_to_list": "Add Contact to This List",
    "add_to_list": "Add to List",
    "edit_custom_fields": "Edit Custom Fields",
    "bulk_edit_custom_fields": "Bulk Edit Custom Fields",
    "remove_list": "Remove list",
    "add_contact": "Add Contact"
  },
  "confirmations": {
    "archive_list": "Are you sure you want to archive this list?"
  },
  "errors": {
    "failed_to_create_contact": "Failed to create this contact"
  },
  "share": {
    "read_only_badge": "Read-Only",
    "list_not_found": {
      "title": "This page is unavailable",
      "description": "Sorry, the page you're trying to access cannot be found. Please contact the owner for assistance.",
      "go_to_nexl": "Go to nexl"
    },
    "header": {
      "powered_by": "Powered by",
      "go_to_home_alt": "go to home"
    }
  },
  "remove_list_member": {
    "confirm_title": "Are you sure you want to remove the contact from this list?",
    "confirm_content": "The contact will be removed from this list."
  },
  "key_activity_list": {
    "actions": {
      "add_activity": "Add Activity",
      "open_slide_aria_prefix": "open slide for key activity:",
      "open_slide_title": "open key activity slide",
      "update_activity_aria": "update key activity",
      "update_activity_title": "update key activity",
      "remove_activity_aria_prefix": "remove key activity",
      "remove_activity_title": "remove key activity",
      "edit_custom_fields": "Edit Custom Fields"
    },
    "add_to_list": {
      "modal_header": "Add to Activity List",
      "button": "Add to list",
      "validation": {
        "select_required": "Please select a key activity list"
      }
    },
    "autocomplete": {
      "activity_list_label": "Activity list",
      "no_project_associated": "No project associated"
    },
    "remove_from_list": {
      "confirm_content": "Click confirm to remove this activity from current list, this action will not delete the activity."
    },
    "status": {
      "loading_aria": "loading key activities",
      "more_activities_message": "There are more key activities than shown."
    }
  },
  "warnings": {
    "maximum_contacts_selection": "Maximum contacts for individual selection is 100. To add contacts to a list, please reduce the selection to 100 or use select all contacts."
  },
  "progress_tracker": {
    "my_contacts_title": "My Contacts",
    "bulk_add_description": "Bulk add contacts to list"
  },
  "add_filtered_contacts": {
    "modal_header": "Add Contact",
    "actions": {
      "add_contact": "Add Contact",
      "add_new_contact": "Add New Contact",
      "new_contact": "New Contact",
      "add_to_lists": "Add to Lists({{count}})",
      "view_selected": "View Selected",
      "clear_selection": "Clear selection"
    },
    "filters": {
      "company_type": "Company type",
      "relationship_partner": "Relationship partner",
      "known_by": "Known by",
      "consent_status": "Consent status",
      "key_activity": "Key activity"
    },
    "table": {
      "headers": {
        "contact": "Contact",
        "company": "Company",
        "location": "Location",
        "last_interaction": "Last Interaction"
      },
      "personal_contact": "-"
    },
    "bulk_add": {
      "success_message": "Request sent. It might take a few minutes to see all the contacts in the target list"
    },
    "empty_state": "No contacts found. Review your search filters or add a new contact."
  },
  "blocked_contacts": {
    "modal_header": "Contacts Excluded or Unsubscribed ({{count}})",
    "modal_caption": "Contacts were not added due to exclusion rules or unsubscribes. Please check with admin for details.",
    "view_contacts_not_added": "View contacts not added"
  },
  "excluded_contacts": {
    "modal": {
      "title_excluded_unsubscribed": "Excluded/Unsubscribed",
      "title_excluded": "Excluded",
      "caption_not_in_list": "Some contacts weren't added due to exclusion rules or unsubscribes. You can only edit contacts in your list.",
      "caption_in_list": "{{count}} contacts match the exclusion rules. Update their status to include them, or remove them from this marketing list.",
      "view_contacts_not_added": "View contacts not added"
    },
    "table": {
      "headers": {
        "contact": "Contact",
        "company": "Company",
        "exclusion_rules": "Exclusion Rules"
      }
    },
    "reasons": {
      "user_unsubscribed": "User Unsubscribed",
      "company_blocked": "Company Blocked",
      "contact_blocked": "Contact Blocked",
      "consent_status_unsubscribed": "Consent status unsubscribed",
      "none": "None",
      "reason": "Reason",
      "created_by": "Created By",
      "field": "Field"
    },
    "actions": {
      "save_and_add_to_list": "Save and Add to List",
      "remove_from_list": "Remove from List",
      "toggle_details": "exclusion details",
      "hide": "hide",
      "show": "show"
    },
    "alerts": {
      "exclusion_rules_prevented": "Exclusion rules prevented some contacts from being added.",
      "see_list_to_review": "See the list to review."
    },
    "warnings": {
      "company_block_cannot_modify": "This contact was excluded due to a company block and cannot be modified.",
      "no_permission_contact_admin": "You don't have permission to edit the exclusion rules. Please contact admin for detail.",
      "no_permission_add_to_contacts": "You don't have permission to edit the exclusion rules. Please add this contact to My Contacts to make changes."
    }
  },
  "list_membership": {
    "header": {
      "title": "List memberships"
    },
    "empty": {
      "description": "This contact is not in any list yet. Click on button below to begin.",
      "marketing_redirect": "For marketing list, head to the Marketing Settings tab."
    },
    "marketing": {
      "notice": "This contact is part of marketing list.",
      "view_details": "View Details"
    },
    "add_to_marketing_list": "Add to Marketing List",
    "unsubscribed": {
      "description_1": "This contact has been removed from all marketing list.",
      "description_2": "Change consent status above to enable the marketing list on this contact."
    },
    "edit_consent": "Edit Consent",
    "marketing_empty": {
      "description": "Get your marketing going by adding contacts to your list."
    },
    "icons": {
      "marketing": "marketing list",
      "shared_contact_list": "shared contact list",
      "personal_contact_list": "personal contact list",
      "project_contact_list": "project contact list"
    }
  },
  "add_contact_to_list": {
    "errors": {
      "failed_to_create_contact": "Failed to create this contact"
    },
    "validation": {
      "contact_required": "Contact is required"
    },
    "form": {
      "label_contact": "Contact",
      "placeholder_select_contact": "Which contact do you want to merge into",
      "submit": "Add Contact to This List"
    }
  },
  "grid": {
    "columns": {
      "actions": "Actions",
      "contact": "Contact",
      "first_name": "First Name",
      "last_name": "Last Name",
      "open_tasks": "Open Tasks",
      "last_updated": "Last Updated",
      "email": "Email",
      "job_title": "Job Title",
      "company": "Company",
      "company_type": "Company Type",
      "contact_consent_status": "Contact Consent Status",
      "tags": "Tags",
      "last_interaction": "Last Interaction",
      "added_datetime": "Added Datetime",
      "last_meeting": "Last Meeting",
      "last_sent_email_at": "Last Sent Email At",
      "last_received_email_at": "Last Received Email At",
      "number_of_interactions": "Number of Interactions",
      "number_of_meetings": "Number of Meetings",
      "number_of_sent_emails": "Number of Sent Emails",
      "number_of_received_emails": "Number of Received Emails",
      "number_of_total_emails": "Number of Total Emails",
      "phone_numbers": "Phone Numbers",
      "linkedin_url": "Linkedin Url",
      "twitter_url": "Twitter Url",
      "educations": "Educations",
      "company_tags": "Company Tags",
      "company_industry_names": "Company Industry Names",
      "company_internal_industry_names": "Company Internal Industry Names",
      "company_website": "Company Website",
      "company_linkedin_url": "Company Linkedin Url",
      "company_twitter_url": "Company Twitter Url",
      "company_correspondence_numbers": "Company Correspondence Numbers",
      "company_correspondence_emails": "Company Correspondence Emails",
      "who_knows": "Who Knows",
      "added_by": "Added By",
      "contact_location": "Contact Location",
      "contact_street_address": "Contact Street Address",
      "contact_city": "Contact City",
      "contact_state": "Contact State",
      "contact_postcode": "Contact Postcode",
      "contact_country": "Contact Country",
      "contact_office_location": "Contact Office Location",
      "office_street_address": "Office Street Address",
      "office_city": "Office City",
      "office_state": "Office State",
      "office_postcode": "Office Postcode",
      "office_country": "Office Country",
      "company_client_id": "Company Client ID",
      "company_group_id": "Company Group ID",
      "email_suffix": "(Email)",
      "edit": "Edit"
    }
  },
  "status": {
    "active": "Active",
    "archived": "Archived",
    "added": "Added",
    "select_aria_label": "select list status"
  },
  "contact_list_form": {
    "create_aria_label": "Create Contact List",
    "create_title": "Create Contact List",
    "create_button": "Create Contact List",
    "rename_header": "Rename list",
    "new_header": "New Contact List",
    "render_mode": {
      "default": {
        "title": "Default",
        "content": "Add up to 10,000 contacts. Extensive search, sorting and filters. Suitable for prospecting or event lists."
      },
      "advanced": {
        "title": "Advanced",
        "content": "Add unlimited number of contacts. Improved performance. Limited search, sorting and filters. Suitable for Marketing Lists."
      }
    },
    "name_label": "Name",
    "name_placeholder": "Name",
    "allow_duplicates_label": "Enable duplicate contacts",
    "marketing_list_label": "Set as Marketing List"
  }
}
